import gql from 'graphql-tag'
import itemFragment from './itemFragment.gql'

export default gql`
  fragment legacyOrderFragment on LegacyOrder {
    id
    coupon_code
    exchange_rate_value
    total_actual_weight
    total_estimated_weight
    min_shipping_days
    max_shipping_days
    min_expected_delivery
    max_expected_delivery
    orders_wrapper{
      id
    }
    shipping_method {
      id
      shipping_type {
        id
        type {
          name
          name_ar
        }
      }
      ship_address {
        id
      }
    }
    shipping_types {
      id
      half_kg
      min_days
      max_days
      type {
        name
        name_ar
      }
    }
    details{
      intl_shipping_delay{
        min
        max
      }
      us_domestic_delay{
        min
        max
      }
      clearance_delay{
        min
        max
      }
      order_processing_delay{
        min
        max
      }
    }
    in_usd {
      total_customs
      total_tax
      total_clearance_charges
      shipping_intl
      subtotal
      delivery_fee
      payment_fee
      total_promotions
      total_adjustments
      total_price
      grand_total
      total_items
      fees
    }
    total_usa_domestic_shipping_fee
    grand_total
    subtotal
    store_shipping_items {
      id
      store_shipping_policy{
        id
      }
      store {
        name
      }
      name
      type
      price
      min_shipping_days
      max_shipping_days
    }
    manual_store_shipping_items {
      id
      store_shipping_policy{
        id
      }
      store {
        name
      }
      name
      type
      price
      min_shipping_days
      max_shipping_days
    }
    auto_store_shipping_items {
      id
      store_shipping_policy{
        id
      }
      store {
        name
      }
      name
      type
      price
      min_shipping_days
      max_shipping_days
    }
    store {
      id
      name
      delayed
      link
      variable_shipping_cost
      store_shipping_policies{
        id
        name
        min_shipping_days
        max_shipping_days
        price
      }
    }
    items {
      ...itemFragment
    }
    saved_items {
      ...itemFragment
    }
  }
  ${itemFragment}
`


// WEBPACK FOOTER //
// ./app/containers/LegacyCartPage/graphql/legacyOrderFragment.gql.js